module.exports = __webpack_public_path__ + "static/media/bears_ice_coffee.3101c08b.jpg";